<template>
  <el-button @click="btnClickHandler" :type="type" :disabled="startFlag">
    <slot></slot>
    <span v-show="startFlag"> ({{ countDownTime }} s)</span>
  </el-button>
</template>

<script>
  export default {
    name: 'CountDownButton',
    props:{
      time: Number,   //倒计时
      type: String,   // 按钮类型
      clickStart: {   // 点击后自动开始
        type:Boolean,
        default: false,
      },
      format: {
        type: String,
        default: 's',
      },
    },
    data(){
      return {
        countDownTime: this.time,
        timer: null,
        startFlag: false,
      }
    },
    watch: {
    },
    methods:{
      stop(){
        console.log('cd close')
        if (this.timer != null) {
          clearInterval(this.timer)
          this.timer = null
          this.startFlag = false
          this.$emit('finish')
        }
      },
      /**
       * 开始倒计时
       */
      start(){
        console.log('cd start')
        this.startFlag = true
        if (this.timer === null) {
          this.countDownTime = this.time
          this.timer = setInterval(()=> {
            console.log(this.countDownTime)
            if (this.countDownTime === 0) {
              this.stop()
            }else {
              this.countDownTime--
            }
          }, 1000)
        }
      },
      btnClickHandler(){
        if (this.clickStart === true) {
          this.start()
        }
        this.$emit('click')
      },
    },
  }
</script>

<style scoped>

</style>
